const stripSlashesFromPath = (path: string) => {
  return path.trim().replace(/^\/+|\/+$/g, "");
};

export default stripSlashesFromPath;
